import http from '@/api/common'

export default {
  // Get context for associated devices
  getContext() {
    return http.get('ConnectedDevices/GetContext')
  },
  saveConnectedDevices(manufacturerDeviceId, deviceIds) {
    return http.post('ConnectedDevices/SetConnectedDevices', {
      DeviceIds: deviceIds
    }, {
      params: {
        manufacturerDeviceId
      }
    })
  },
  upsertManufacturerDevice(manufacturerDevice) {
    return http.post('ConnectedDevices/UpsertManufacturerDevice', manufacturerDevice)
  },
  removeManufacturerDevice(manufacturerDeviceId) {
    return http.post(
      'ConnectedDevices/RemoveManufacturerDevice',
      null,
      {
        params: {
          manufacturerDeviceId
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/connected-devices.js